import React, { useImperativeHandle } from "react";

import { Icon } from "components/Icon";
import { Collapse } from "react-collapse";
import styled from "styled-components";

import { useNumbersFilterForm } from "./hooks/useNumbersFilterForm";
import { DEFAULT_EQUAL_SIGN } from "const"
import Checkbox from "hoc/Checkbox";
import { FilterSectionFlexboxGrid, StyledItemFitWidth } from "components/base/FitContainers";
import Search, { str } from "components/Filters/Search";
import CustomField from "components/Form/CustomField";
import SDE from "components/Filters/SDE";
import DE from "components/Filters/DE";
import WZ from "components/Filters/WZ";
import NumbersDownloadDropdown from "./NumbersDownloadDropdown";
// import * as S from "./styled";
import "./Allocated.css";

import { DatePicker, Form, IconButton, Radio, RadioGroup, Schema, SelectPicker } from "rsuite";

const { StringType } = Schema.Types;
const equalObject = { "<": -1, "=": DEFAULT_EQUAL_SIGN, ">": 1 };

const numbersFiltersModel = Schema.Model({ str });
const prefixesFiltersModel = Schema.Model({
    prefix: StringType().pattern(/^[0-9][\d]*$/, "The prefix must contain only digits")
        .maxLength(15, "The maximum is 15 characters"),
    mcc_mnc: StringType().pattern(/^[0-9][\d]*$/, "The mcc and mcc must contain only digits")
        // .minLength(3, "The minimum is 6 characters.")
        .maxLength(15, "The maximum is 15 characters"),
});


const NumbersFilters = React.forwardRef((
    {
        onChange,
        disabled,
        filters,
        proxy,
        currentDisplay,
        currentRangeNumber,
        onChangeGroup,
        isMobile,

        isGanTrunks,

        isTransitTrunks,

        downloadLoading,
        downloadDisabled,
        onDownloadNumbersCsv,
        onDownloadNumbersCsv1,
        onDownloadOnlyNumbersCsv,
        onDownloadOnlyNumbersCsv1,

    }, ref) => {

    const [showFilters, setShowFilters] = React.useState(false);
    const isSuppliersTrunks = isTransitTrunks || isGanTrunks;
    const { formValue, handleChange, getValues } = useNumbersFilterForm({
        filters,
        onChange,
        proxy,
        model: isTransitTrunks ? prefixesFiltersModel : numbersFiltersModel,
        isSuppliersTrunks,
        currentRangeNumber,
        currentDisplay,
    });

    useImperativeHandle(ref, () => ({ getValues, formValue }), [getValues, formValue]);

    const numbersFilters = (
        <FilterSectionFlexboxGrid controlable={!isMobile}>
            <StyledForm
                mb={20}
                formValue={formValue}
                model={numbersFiltersModel}
                readOnly={disabled}
                onChange={handleChange}
            >
                <StyledItemFitWidth controlable={!isMobile} isMobile={isMobile}>
                    <StyledField>
                        <Search
                            name="str"
                            disabled={disabled}
                            placeholder="Range/Number search"
                        />
                    </StyledField>

                    {!isGanTrunks && <StyledField>
                        <WZ disabled={disabled} />
                    </StyledField>}

                    {!isGanTrunks && <StyledField>
                        <DE disabled={disabled} />
                    </StyledField>}

                    {!isGanTrunks && <StyledField>
                        <SDE disabled={disabled} />
                    </StyledField>}

                    {currentDisplay === "trunk_number" &&
                        <StyledField>
                            <Form.Group style={{ marginRight: 10 }}>
                                <CustomField
                                    name="start_date"
                                    style={{ width: 150 }}
                                    accepter={DatePicker}
                                    placeholder="Enter Date"
                                    disabled={disabled}
                                />
                            </Form.Group>
                        </StyledField>
                    }

                    {currentDisplay === "trunk_number" &&
                        <StyledField>
                            <Form.Group>
                                <CustomField
                                    labelKey="label"
                                    valueKey="value"
                                    cleanable={false}
                                    searchable={false}
                                    accepter={SelectPicker}
                                    disabled={!formValue.start_date || disabled}
                                    name="start_date_inequation"
                                    data={Object.keys(equalObject).map(label => ({ value: equalObject[label], label }))}
                                />
                            </Form.Group>
                        </StyledField>
                    }
                    {!isSuppliersTrunks &&
                        <StyledField>
                            <Checkbox disabled={disabled} name="actual">
                                Show outdated/revoked
                            </Checkbox>
                        </StyledField>
                    }
                </StyledItemFitWidth>
            </StyledForm>
        </FilterSectionFlexboxGrid>
    );

    const transitTrunksFilters = (
        <FilterSectionFlexboxGrid controlable={!isMobile}>
            <Form
                formValue={formValue}
                model={prefixesFiltersModel}
                readOnly={disabled}
                onChange={handleChange}
            >
                <StyledItemFitWidth controlable={!isMobile} isMobile={isMobile}>
                    <StyledField>
                        <Search
                            name="prefix"
                            disabled={disabled}
                            placeholder="Prefix"
                        />
                    </StyledField>
                    <StyledField>
                        <Form.Group>
                            <Form.Control
                                cleanable={false}
                                searchable={false}
                                disabled={disabled}
                                name="mcc_mnc"
                                placeholder="MCC MNC"
                            />
                        </Form.Group>
                    </StyledField>
                </StyledItemFitWidth>
            </Form>
        </FilterSectionFlexboxGrid>
    );

    const ganTrunksFilters = (
        <FilterSectionFlexboxGrid controlable={!isMobile}>
            <Form
                formValue={formValue}
                model={numbersFiltersModel}
                readOnly={disabled}
                onChange={handleChange}
            >
                <StyledItemFitWidth controlable={!isMobile} isMobile={isMobile}>
                    <StyledField>
                        <Search
                            name="str"
                            disabled={disabled}
                            placeholder="Number/Group Name"
                            style={{ minWidth: 200 }}
                        />
                    </StyledField>

                    {currentDisplay === "numbers" &&
                        <StyledField>
                            <WZ disabled={disabled} />
                        </StyledField>
                    }
                    {currentDisplay === "numbers" &&
                        <StyledField>
                            <DE disabled={disabled} />
                        </StyledField>
                    }
                    {currentDisplay === "numbers" &&
                        <StyledField>
                            <SDE disabled={disabled} />
                        </StyledField>
                    }

                    {currentDisplay === "numbers" &&
                        <StyledField>
                            <Checkbox
                                disabled={disabled}
                                name="show_allocated_numbers"
                                // checked={(filters || {}).show_allocated_numbers === false}
                                defaultChecked={true}
                            >
                                Show allocated numbers
                            </Checkbox>
                        </StyledField>}
                    {currentDisplay === "numbers" &&
                        <StyledField>
                            <Checkbox
                                disabled={disabled}
                                name="show_unallocated_numbers"
                                // checked={(filters || {}).show_unallocated_numbers === false}
                                defaultChecked={true}
                            >
                                Show unallocated numbers
                            </Checkbox>
                        </StyledField>}
                    {currentDisplay === "numbers" &&
                        <StyledField>
                            <Checkbox
                                disabled={disabled}
                                name="show_test_numbers"
                                // checked={(filters || {}).show_test_numbers === false}
                                defaultChecked={true}
                            >
                                Show test numbers
                            </Checkbox>
                        </StyledField>}
                    {currentDisplay === "numbers" &&
                        <StyledField>
                            <Checkbox
                                disabled={disabled}
                                name="show_block_allocation_numbers"
                                // checked={(filters || {}).show_block_allocation_numbers === false}
                                defaultChecked={true}
                            >
                                Show block allocation numbers
                            </Checkbox>
                        </StyledField>}

                </StyledItemFitWidth>
            </Form>
        </FilterSectionFlexboxGrid>
    );

    return (
        <>
            {/* refactor after ATX-2853 */}
            {isTransitTrunks ?
                transitTrunksFilters
                : isGanTrunks ?
                    ganTrunksFilters
                    : <></>}

            {!isSuppliersTrunks && isMobile &&
                <StyledIconButton
                    icon={<Icon icon="filter" />}
                    appearance={showFilters ? "primary" : "default"}
                    onClick={() => setShowFilters(!showFilters)}
                >
                </StyledIconButton>
            }

            {!isGanTrunks && isMobile &&
                <NumbersDownloadDropdown
                    loading={downloadLoading}
                    disabled={downloadDisabled}
                    onDownloadNumbersCsv={onDownloadNumbersCsv}
                    onDownloadNumbersCsv1={onDownloadNumbersCsv1}
                    onDownloadOnlyNumbersCsv={onDownloadOnlyNumbersCsv}
                    onDownloadOnlyNumbersCsv1={onDownloadOnlyNumbersCsv1}
                    isMobile={isMobile}
                />
            }

            {!isSuppliersTrunks && <Collapse isOpened={!isMobile || showFilters}>
                {numbersFilters}
                {isMobile &&
                    <RadioGroup
                        inline
                        onChange={onChangeGroup}
                        defaultValue={"trunk_number"}
                        name="radioList"
                    >
                        <Radio value="trunk_number" disabled={disabled}>Numbers</Radio>
                        <Radio value="price_range" disabled={disabled}>Ranges</Radio>
                        <Radio value="subdestination" disabled={disabled}>Subdestinations</Radio>
                    </RadioGroup>
                }
            </Collapse>}
        </>
    );
});

export default NumbersFilters;

const StyledField = styled.div`
    display: inline-block;
    
    margin-right: 15px;
    margin-bottom: ${props => props.mb || 0}px;

    @media (max-width: 767px) {
        display: block;
        margin-right: 0;
        margin-bottom: 15px;

        .rs-form-control-wrapper {
            margin-bottom: 0px !important;
        }
        
        .rs-input {
            min-width: 30px;
        }
        
        && .rs-control-label {
            display: block;
            margin-bottom: 5px;
            margin-top: 0;
        }
        
        && .rs-form-group {
            display: block;
        }
    }
`;

const StyledForm = styled(Form)`
    && {
        margin-bottom: ${props => props.mb || 0}px;
    }
`;

const StyledIconButton = styled(IconButton)`
    && {
        margin-right: 15px;
    }
`;
